export default {"src":"/_next/static/media/prev-icon.ba5adebd.svg","height":113,"width":65};